module.exports = __webpack_public_path__ + "static/ModernEra-Bold-e6a7a1149ee459107ab89830379667bc.woff";